import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { DealerListItem } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { getIsOpenInformation } from '../../utilities/opening-information';
import { actions } from './app.actions';

interface AppState {
    isOpen: boolean;
    dealers: Loadable<DealerListItem[]>;
}

const initialState: AppState = {
    isOpen: false,
    dealers: null,
};

export const state = createFeature({
    name: 'app',
    reducer: createReducer(
        initialState,
        on(
            actions.initPage,
            (state, actions): AppState => ({
                ...state,
                isOpen: actions.isE2e ? false : !getIsOpenInformation(),
            }),
        ),
        on(
            actions.loadDealerListSuccess,
            (state, { dealers }): AppState => ({
                ...state,
                dealers,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectLoadedDealers = createSelector(
            baseSelectors.selectDealers,
            (dealers) => dealers as Loaded<DealerListItem[]>,
        );

        return {
            selectLoadedDealers,
        };
    },
});
